// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3-HV6","title":"AfterBackImages_title__dowZX","images":"AfterBackImages_images__3EMRE"};